import { FormControl, Grid, TextField, Box } from '@mui/material';
//import '../scss/ClientForm.scss';
import intl from 'components/i18n/ReactIntlWrapper';
import ErrorSummary from 'components/common/ErrorSummary';


const ClientForm = ({ errors, input, handleInputChange, disabled }) => {
    return (
        <Box component="form" className='my-3' sx={{width: '100%'}}>
            <Grid container>
                <Grid size={12}>
                    <ErrorSummary errors={errors} showEverything={true} />
                </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent="space-around" sx={{ width: '100%' }}>
                <Grid size={12}>
                    <Box display="flex" gap={2}>
                        <FormControl fullWidth>
                            <TextField
                                id="clientName"
                                name="name"
                                label={intl.get('clientForm.name')}
                                placeholder={intl.get('clientForm.placeholder.name')}
                                value={input?.name}
                                onChange={handleInputChange}
                                disabled={disabled}
                                error={!!errors.name}
                                helperText={errors.name}
                                fullWidth
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <TextField
                                id="clientTradeName"
                                name="tradeName"
                                label={intl.get('clientForm.tradeName')}
                                placeholder={intl.get('clientForm.placeholder.tradeName')}
                                value={input?.tradeName}
                                onChange={handleInputChange}
                                disabled={disabled}
                                error={!!errors.tradeName}
                                helperText={errors.tradeName}
                                fullWidth
                            />
                        </FormControl>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ClientForm;
